// A FrontDesk "Open Hub as them" link lands on /auth/login?impersonation=<token>&username=<email>.
// The token alone is the long-standing flow - the page asks who to impersonate. With the username as
// well, the page fills it in and submits itself, so a CS operator goes from FrontDesk to the Hub in
// one click. FrontDesk builds the link in api/app/hub.py::hub_impersonation_url; these two param
// names are the contract between the repos.

export const IMPERSONATION_TOKEN_PARAM = 'impersonation';
export const IMPERSONATION_USERNAME_PARAM = 'username';

export function readImpersonationPrefill(searchParams: URLSearchParams): { username: string } | null {
  const token = searchParams.get(IMPERSONATION_TOKEN_PARAM)?.trim();
  const username = searchParams.get(IMPERSONATION_USERNAME_PARAM)?.trim();
  if (!token || !username) {
    return null;
  }
  return { username };
}
